import HomeNavigation from "../../components/Common/HomeNavigation";
import PageTitle from "../../components/Common/PageTitle";
import CouponHistory from "../../components/CouponHistory";
import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";

const MY_REWARDS_TEXT = msg({
  id: "User_my_rewards_text",
  message: "My Rewards",
});

export default function History() {
  const { _: i18n } = useLingui();
  return (
    <>
      {/* Page title */}
      <PageTitle title={i18n(MY_REWARDS_TEXT)} />
      <HomeNavigation />
      <CouponHistory />
    </>
  );
}
